<template>
    <div>
      <modal size="medium">
        <div slot="header" v-if="team">
            <div class="row columns">
                Achat de joueur :
            </div>
            <div class="row columns small-font">
                <div class="small-font">choisissez les noms et les numéros des nouveaux joueurs</div>
            </div>
        </div>
        <div v-if="localPurchaseList" slot="body">
            <div class="row columns" v-if="localPurchaseList.players">
                <div class="large-11 large-centered">
                  Nouveaux Joueurs
                <table>
                    <thead class="roster">
                        <tr>
                            <th width="10%">N°</th>
                            <th width="40%">Position</th>
                            <th width="40%">Nom</th>
                        </tr>
                    </thead>
                    <tbody class="roster">
                        <tr v-for="player in localPurchaseList.players">
                            <td class="number">
                              <input type="number" min="0" v-model="player.num">
                            </td>
                            <td >{{getPosition(player.ref_roster_line)}}</td>
                            <td>
                                <input v-model="player.name" class="player-name" type="text">
                            </td>
                        </tr>
                    </tbody>
                </table>
                </div>
              </div>
              <br>
              <div class="row columns" v-if="localPurchaseList.journeymen">
                <div class="large-11 large-centered">
                  Journaliers Engagés
                  <table>
                    <thead class="roster">
                    <tr>
                      <th width="10%">N°</th>
                      <th width="40%">Position</th>
                      <th width="40%">Nom</th>
                    </tr>
                    </thead>
                    <tbody class="roster">
                    <tr v-for="jm in localPurchaseList.journeymen">
                      <td class="number">
                        <input type="number" min="0" v-model="jm.num">
                      </td>
                      <td >{{roster.journeyman.position}}</td>
                      <td>
                        <input v-model="jm.name" class="player-name" type="text">
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
            </div>
          </div>
          <div slot="footer" class="panel-footer" >
              <div class="error">{{errorMsg}}
              </div>
              <div class="row columns">
                <button class="large-4 light-grey-button" @click="$emit('closeMessage')">Annuler</button>
                <button class="large-4 large-offset-2" @click="validate()">valider</button>
              </div>
          <br>
          </div>
      </modal>
    </div>
</template>
<script>
import modal from './modal.vue'
// import { mapGetters } from 'vuex'

export default {
  name: 'playerPurchaseModal',
  components: {
    modal
  },
  props: {
    'team': null,
    'roster': null,
    'purchaseList': null
  },
  data () {
    return {
      localPurchaseList: {},
      errorMsg: null
    }
  },
  methods: {
    getAvailableNumber () {
      let avail = []
      for (let i = 1; i <= 16; i++) {
        let foundNum = this.team.players.find(pl => pl !== undefined && pl.num === i)
        let foundNewNum = this.localPurchaseList.players.find(pur => pur !== undefined && pur.num === i)
        if (foundNum === undefined && foundNewNum === undefined) {
          avail.push(i)
        }
      }
      return avail
    },
    getPosition (id) {
      let foundLine = this.roster.roster_lines.find(rl => rl !== undefined && rl.id === id)
      return foundLine.position
    },
    validate () {
      let unchosenNumberPlayer
      let unchosenNumberJm
      if (this.localPurchaseList.players) {
        unchosenNumberPlayer = this.localPurchaseList.players.find(lp => lp !== undefined && (lp.num === 0 || lp.num === undefined || lp.num === ''))
      }
      if (this.localPurchaseList.journeymen) {
        unchosenNumberJm = this.localPurchaseList.journeymen.find(lp => lp !== undefined && (lp.num === 0 || lp.num === undefined || lp.num === ''))
      }
      if (unchosenNumberPlayer !== undefined || unchosenNumberJm !== undefined) {
        this.errorMsg = 'tous les numéros ne sont pas choisis'
        return
      } else {
        this.errorMsg = null
      }
      this.$emit('validate', this.localPurchaseList)
    }
  },
  created () {
    this.localPurchaseList = this.purchaseList
    let cpt = 0
    let avail = this.getAvailableNumber()
    this.localPurchaseList.players.forEach(pl => {
      pl.num = avail[cpt]
      cpt++
      pl.name = ''
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.small-font {
  font-size:0.8rem
}
.error {
  font-size:0.9rem;
  color: red;
  padding-bottom: 1rem
}

.modal-mask {
  position:fixed
}

.roster tr:nth-of-type(odd) {
    transition: background-color 0.15s;
    background-color: #E9EDEF;
}

.roster tr:nth-of-type(even) {
    background-color: #ffffff;
}

/***** gestion des formats de cellules*/

thead tr th {
    background-color: #ffffff;
    text-align: center;
    font-weight: 200;
    font-size:0.8rem;
}

tr td{
    padding: 0.3rem 0.2rem;
    text-align: center;
    font-size:0.7rem;
}
tr td input, tr td select{
    padding: 0.5rem 0.5rem;
    text-align: center;
    font-size:0.7rem;
    margin: 0rem;
}
</style>



// WEBPACK FOOTER //
// player-purchase-modal.vue?0ae9139e